import React from 'react';
import Select from 'react-select';
import RC_Style from '../../../../../assets/css/components/admin/plugins/reportesComercialesStyle';

const SelectRate = ({ setRate, rate, label, rates }) => {
    const options = (rates || []).map(rt => ({
        value: rt.id,
        label: rt.name,
    }));

    return (
        <div style={{ marginBottom: '4px' }}>
            <RC_Style.Label htmlFor="rate">{label}</RC_Style.Label>
            <Select
                id="rate"
                value={rate && options.find(option => option.value === rate.value)}
                onChange={(selectedOption) => setRate(selectedOption)}
                options={options}
                styles={RC_Style.customStyles}
                isClearable={false}
                placeholder="Seleccione..."
            />
        </div>
    );
};

export default SelectRate;
